var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import cssbeautify from 'cssbeautify';
import { objectReduce } from 'fela-utils';

function addBeautifier(renderer, options) {
  renderer.subscribe(function () {
    renderer.fontFaces = cssbeautify(renderer.fontFaces, options);
    renderer.keyframes = cssbeautify(renderer.keyframes, options);
    renderer.statics = cssbeautify(renderer.statics, options);
    renderer.rules = cssbeautify(renderer.rules, options);

    renderer.mediaRules = objectReduce(renderer.mediaRules, function (mediaRules, rules, query) {
      mediaRules[query] = cssbeautify(rules, options);
      return mediaRules;
    }, {});
  });

  return renderer;
}

var defaultOptions = {
  indent: '  ',
  openbrace: 'end-of-line',
  autosemicolon: false
};

export default function beautifier() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return function (renderer) {
    return addBeautifier(renderer, _extends({}, defaultOptions, options));
  };
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/fela-beautifier/es/index.js
// module id = 757
// module chunks = 0